import {
	INITIAL_BALANCE_REQUEST,
	FINAL_BALANCE_REQUEST,
	FETCH_BALANCE_SUCCESS,
	FETCH_BALANCE_ERROR,
	DELETE_BALANCE_SUCCESS,
	SAVE_BALANCE_SUCCESS,
} from "../types/balance.types";

const initialState = {
	balances: [],
	customers: [],
	balance_status: [],
	estates: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
	error: null,
};

function balances(state = initialState, action) {
	switch (action.type) {
		case INITIAL_BALANCE_REQUEST:
			return {
				...state,
				isFetching: true,
				error: null,
			};
		case FINAL_BALANCE_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		case FETCH_BALANCE_SUCCESS:
			return {
				...state,
				isFetching: false,
				balances: action.payload.balances,
				customers: action.payload.customers,
				balance_status: action.payload.balance_status,
				estates: action.payload.estates,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		case FETCH_BALANCE_ERROR:
			return {
				...state,
				isFetching: false,
				error: action.payload.error,
				balances: [],
				customers: [],
				balance_status: [],
				estates: [],
				last_page: 0,
				from: 0,
				to: 0,
			};

		case DELETE_BALANCE_SUCCESS:
			return {
				...state,
				isFetching: false,
				balances: action.payload.balances,
			};

		case SAVE_BALANCE_SUCCESS:
			return {
				...state,
				isFetching: false,
				balances: action.payload.balances,
			};

		default:
			return state;
	}
}

export default balances;
